/************
 Product Dropdowns
 ************/

document.querySelectorAll(".productDropdown").forEach(element => {

    // add event listener to button
    element.querySelector(".productDropdownButton").addEventListener("click", function () {
        // toggle dropdown
        element.classList.toggle("open");
    });
});

// dropdown logo popovers
document.querySelectorAll(".productSpecificationsDropdownLogo").forEach(element => {
    // get tooltip template
    const template = document.querySelector(`.productSpecificationsDropdownLogoTooltipTemplate[id="${element.alt}"]`);

    tippy(element, {
        content: template.innerHTML,
        allowHTML: true,
        theme: 'light'
    });
})

/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        prevEl: '#productVisualSwiperPrev',
        nextEl: '#productVisualSwiperNext',
    },
});


// change slide on thumbnail click
document.querySelectorAll(".productVisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        productSwiper.slideTo(this.dataset.index - 1);
    });
});